import { useHttpStore } from "@/stores/http/index.ts";
import { toast } from "vue-sonner";

const handleResponseErrors = (res, module) => {
  const { dispatch } = module;
  if (res.status === 401 || res.status === 403) {
    toast.error("User does not have permissions to access this resource");
  }
  dispatch(
    "setServerErrorMessage",
    { message: "Error while saving", returnToPreviousPage: false },
    { root: true }
  );
};

const httpRequest = async (module, { func, config }) => {
  const { isCms, isAuth } = config;
  const { commit } = module;
  const httpStore = useHttpStore();
  const isAuthenticated = await httpStore.auth0Client.isAuthenticated();
  if (isAuth && !isAuthenticated) {
    throw new Error("User must be authenticated to use this endpoint.");
  }

  const toggleIsSaving = (isSaving) =>
    isCms && commit("setIsSaving", isSaving, { root: true });

  try {
    toggleIsSaving(true);
    const res = await func;
    if (res.status) {
      if (res.status >= 200 && res.status < 300) {
        toggleIsSaving(false);
        return res;
      }
      handleResponseErrors(res, module);
    }
    toggleIsSaving(false);
    return res;
  } finally {
    toggleIsSaving(false);
  }
};

export { httpRequest };
